import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

export const mutateShowcaseDelete = ({ showcaseId }) => {

    const mutation = useMutation({
        mutationKey: ['showcase-delete', showcaseId],
        mutationFn: async () => {
            const res = await axios.delete(route('studio.v1.api.showcases.destroy', showcaseId));
            return res;
        },
        onSuccess: async ({ data }) => {
            notifications.show({
                color: 'green',
                title: 'Success',
                message: data?.message || 'Demo ad deleted',
            })
        },
        onError: async ({ response }) => {
            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || '',
            })
        }
    });

    return mutation;
}
